import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import { connect } from 'react-redux';
import { Button } from '@ipc/ipc-components';
import ListTable from '../../../../../common/list-table/components/ListTable';
import { StyledModalForm } from '../../../../../common/list-table/helpers/formModal.styles';
import { getMrdDeviceListByCountryColumns, getMrdDeviceListByCountryData } from '../../redux/selectors/HandlersSelectors';
import TableDefinitions from '../../../../../common/TableDefinitions';

function HandlerCopyDialog(props) {
  const [selectedMrdDevice, updateSelectedMrdDevice] = useState('');
  const [tableData, updateTableData] = useState([]);
  const {
    mrdDeviceListByCountryData,
    mrdDeviceListByCountryColumns,
    isOpen,
    handleConfirm,
    handleCancel,
    targetMrdName,
  } = props;

  useEffect(() => {
    updateTableData(mrdDeviceListByCountryData.filter((item) => item.mrdName !== targetMrdName));
  }, [mrdDeviceListByCountryData, targetMrdName]);

  const handleCancelButton = () => {
    updateSelectedMrdDevice('');
    handleCancel();
  };

  const getOnClickOfMrdDeviceTable = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo.original.mrdName === selectedMrdDevice ? '#dbffdb' : null,
        },
        onClick: () => {
          updateSelectedMrdDevice(rowInfo.original.mrdName);
        },
      };
    }
    return {};
  };
  return (
    <Dialog open={isOpen}>
      <DialogTitle id="simple-dialog-title">Copy Handler Settings</DialogTitle>
      <StyledModalForm>
        <ListTable
          listId={TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.id}
          columns={mrdDeviceListByCountryColumns}
          data={tableData}
          getTrProps={getOnClickOfMrdDeviceTable}
        />
        <div className="after-box">
          <Button className="cancel" onClick={handleCancelButton}>Cancel</Button>
          <Button
            onClick={() => handleConfirm(selectedMrdDevice)}
            className={`primary-button-${selectedMrdDevice === ''} action`}
            disabled={selectedMrdDevice === ''}
          >
            Confirm
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}
function mapStateToProps(state) {
  return {
    mrdDeviceListByCountryData: getMrdDeviceListByCountryData(state),
    mrdDeviceListByCountryColumns: getMrdDeviceListByCountryColumns(state),
  };
}
HandlerCopyDialog.propTypes = {
  mrdDeviceListByCountryData: PropTypes.arrayOf(PropTypes.object),
  mrdDeviceListByCountryColumns: PropTypes.arrayOf(PropTypes.object),
  isOpen: PropTypes.bool,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
  targetMrdName: PropTypes.string,
};
export default connect(mapStateToProps)(HandlerCopyDialog);
